var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE4StairwayDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66 56v4H50V48H36V36H22V25H10v-4h16v11h14v12h14v12h12zM52.14 36.9H63.9V25.14l-4.58 4.35L42.83 13 40 15.83l16.49 16.49-4.35 4.58z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E4_Stairway_down.2ce9d9fc.svg";
export { SvgE4StairwayDown as ReactComponent };